import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  formInputStyles,
} from "../../../../constants/Styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const InventoryContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const InfoLine = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  > div {
    width: 30%;
    overflow-wrap: break-word;
  }
`;

export const Description = styled.div`
  font-weight: ${FONT_WEIGHT.weight500};
  line-height: 24px;

  > span {
    color: ${COLORS.secondaryLight};
    font-weight: ${FONT_WEIGHT.weight400};
    font-size: ${FONT_SIZE.size13};
    line-height: 16px;
  }
`;

export const ValueArea = styled.div`
  ${formInputStyles};

  > textarea {
    width: 100%;
  }
`;
